import React from "react";
import { Bar, XAxis, YAxis, BarChart, ReferenceLine, LabelList, Tooltip, ResponsiveContainer } from "recharts";

const calculateValue = (value) => {
    let arr = []
    if (value.Bottom) {
        value.Bottom.forEach(item => {
            item.fill = '#a9bcd0'
            arr.push(item)
        })
    }
    if (value.Top) {
        value.Top.forEach(item => {
            item.fill = '#0353a4'
            arr.push(item)
        })
    }

    return arr
}

const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;

    return (
        <g>
            <text x={value > 0 ? (x + 5) + width : (x - 50) + width} y={y + 15} fontSize={14}>
                {parseInt(value?.toFixed(0))?.toLocaleString()}%
            </text>
        </g>
    );
};

const renderTooltip = (e) => {
    return (
        <div className="dtts-tooltip">
            <span>{e.label}</span>
            <span className='dtts-tooltip-values'>
                {
                    e.payload && (e?.payload?.length) && <span><strong>Inc Vol : {e.payload[0].payload.Activity_Inc_Vol?.toFixed(2)}</strong></span>

                }
            </span>
        </div>
    )
}

function TopBottomFiveChart(props) {
    let graphValue = calculateValue(props?.data)
    return (

        <ResponsiveContainer height={320} width={props.type === 'top' ? '100%' : "56%"}>
            <BarChart
                width={250}
                height={150}
                data={graphValue}
                layout="vertical"
                margin={{ top: 0, right: 50, bottom: 0, left: 50 }}
            >
                <XAxis type="number" hide style={{ fontSize: '12px' }} />
                <YAxis dataKey="ActivityDesc" style={{ fontSize: '12px' }} width={200} type="category" tick={props.type === 'top' ? true : false} axisLine={false} tickLine={false} />
                <Tooltip content={(e) => renderTooltip(e)} />
                <ReferenceLine x={0} stroke='#e6e6e7' />
                <Bar
                    dataKey="Activity_ROI"
                    fill='fill'
                    barSize={20}
                >
                    <LabelList dataKey="Activity_ROI" content={renderCustomizedLabel} fontSize={12} fill={'black'} />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}

export default TopBottomFiveChart;
